function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Instagram, Negative",
    clipPath: "url(#clip0_4457_72761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9993 2.16089C15.2055 2.16089 15.5851 2.17496 16.846 2.2312C18.0179 2.28277 18.6507 2.47964 19.0726 2.6437C19.6304 2.85932 20.0335 3.12181 20.4507 3.53899C20.8725 3.96086 21.1303 4.35929 21.346 4.91709C21.51 5.33895 21.7069 5.97644 21.7584 7.1436C21.8147 8.4092 21.8288 8.78888 21.8288 11.9904C21.8288 15.1966 21.8147 15.5762 21.7584 16.8372C21.7069 18.009 21.51 18.6418 21.346 19.0637C21.1303 19.6215 20.8678 20.0246 20.4507 20.4418C20.0288 20.8636 19.6304 21.1214 19.0726 21.3371C18.6507 21.5011 18.0132 21.698 16.846 21.7496C15.5804 21.8058 15.2008 21.8199 11.9993 21.8199C8.79308 21.8199 8.4134 21.8058 7.15249 21.7496C5.98064 21.698 5.34784 21.5011 4.92597 21.3371C4.36817 21.1214 3.96506 20.859 3.54788 20.4418C3.12601 20.0199 2.8682 19.6215 2.65258 19.0637C2.48852 18.6418 2.29165 18.0043 2.24009 16.8372C2.18384 15.5716 2.16978 15.1919 2.16978 11.9904C2.16978 8.7842 2.18384 8.40452 2.24009 7.1436C2.29165 5.97175 2.48852 5.33895 2.65258 4.91709C2.8682 4.35929 3.1307 3.95617 3.54788 3.53899C3.96974 3.11712 4.36817 2.85932 4.92597 2.6437C5.34784 2.47964 5.98533 2.28277 7.15249 2.2312C8.4134 2.17496 8.79308 2.16089 11.9993 2.16089ZM11.9993 0C8.74152 0 8.33372 0.0140622 7.05406 0.0703111C5.77908 0.12656 4.90254 0.332806 4.14318 0.628112C3.35101 0.937481 2.68071 1.34529 2.0151 2.01558C1.3448 2.6812 0.936993 3.35149 0.627624 4.13898C0.332317 4.90303 0.126072 5.77488 0.0698228 7.04986C0.0135739 8.33421 -0.000488281 8.74201 -0.000488281 11.9998C-0.000488281 15.2575 0.0135739 15.6653 0.0698228 16.945C0.126072 18.2199 0.332317 19.0965 0.627624 19.8558C0.936993 20.648 1.3448 21.3183 2.0151 21.9839C2.68071 22.6495 3.35101 23.062 4.13849 23.3667C4.90254 23.662 5.77439 23.8683 7.04937 23.9245C8.32903 23.9808 8.73683 23.9948 11.9946 23.9948C15.2523 23.9948 15.6601 23.9808 16.9398 23.9245C18.2148 23.8683 19.0913 23.662 19.8507 23.3667C20.6382 23.062 21.3085 22.6495 21.9741 21.9839C22.6397 21.3183 23.0522 20.648 23.3568 19.8605C23.6522 19.0965 23.8584 18.2246 23.9146 16.9497C23.9709 15.67 23.985 15.2622 23.985 12.0044C23.985 8.7467 23.9709 8.33889 23.9146 7.05923C23.8584 5.78426 23.6522 4.90771 23.3568 4.14835C23.0615 3.35149 22.6537 2.6812 21.9834 2.01558C21.3178 1.34997 20.6475 0.937481 19.86 0.6328C19.096 0.337493 18.2241 0.131247 16.9492 0.0749985C15.6648 0.0140622 15.257 0 11.9993 0Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.9994 5.83594C8.59633 5.83594 5.83545 8.59682 5.83545 11.9999C5.83545 15.4029 8.59633 18.1638 11.9994 18.1638C15.4024 18.1638 18.1633 15.4029 18.1633 11.9999C18.1633 8.59682 15.4024 5.83594 11.9994 5.83594ZM11.9994 15.9982C9.79162 15.9982 8.00103 14.2076 8.00103 11.9999C8.00103 9.79211 9.79162 8.00152 11.9994 8.00152C14.2072 8.00152 15.9977 9.79211 15.9977 11.9999C15.9977 14.2076 14.2072 15.9982 11.9994 15.9982Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.8458 5.59236C19.8458 6.38921 19.199 7.03139 18.4068 7.03139C17.6099 7.03139 16.9678 6.38453 16.9678 5.59236C16.9678 4.7955 17.6146 4.15332 18.4068 4.15332C19.199 4.15332 19.8458 4.80018 19.8458 5.59236Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4457_72761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9995,
    height: 23.9995,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-0.000488281)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c3dfdab77cd384d79ee5be8cbd734673.svg";
export { ForwardRef as ReactComponent };